// GCP Configuration for file uploads
const GCP_API_BASE_URL = `${process.env.REACT_APP_SERVER_BASE_URL}/assignment/v1/miscellaneous`

export const GCP_SIGNED_URLS_ENDPOINT = `${GCP_API_BASE_URL}/generate-signed-urls`;
